import React from 'react';
import YouTube from 'react-youtube';

import Authenticated from 'Components/Layouts/Authenticated';
import { Container } from "Components/Utilities";
// ...existing code... (removed unused ModalTrigger / Highlights imports)
import { Link as DomLink } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import JoinUs from 'Components/Partials/JoinUs';
import {faBuilding, faCalendar, faMicrophone, faPlay} from '@fortawesome/free-solid-svg-icons';
import ElementApi from 'Services/Api/Cms/Elements/Element';
import RecordApi from 'Services/Api/Cms/Elements/Record';
import { getRecordValue } from 'Services/CmsHelpers';
import { Loading, Countdown } from 'Components/Partials';
import { ModalTrigger, Modal, ModalHeader, ModalBody } from 'Components/Modal';

/**
 * VideoModal component used with ModalTrigger. Receives `item` prop and `onClose` from ModalContainer.
 */
const VideoModal = ({ item, onClose }) => {
    if (!item) return null;

    const item_video_type = getRecordValue(item, 'video_type');
    const item_video_src = getRecordValue(item, 'video_src');

    return (
        <Modal size="max-w-3xl">
            <ModalHeader onClose={onClose}>{getRecordValue(item, 'title') || 'Highlight'}</ModalHeader>
            <ModalBody containerClassName="p-0">
                <div className="w-full">
                    {item_video_type === 'youtube' && (
                        <YouTube
                            videoId={item_video_src}
                            className="w-full h-full"
                            containerClassName="w-full h-80"
                            opts={{ playerVars: { autoplay: 1, rel: 0 } }}
                        />
                    )}

                    {item_video_type === 'vimeo' && (
                        <div className="relative h-full w-full" style={{ paddingTop: '56.25%' }}>
                            <iframe src={item_video_src}
                                className="absolute top-0 left-0 right-0 bottom-0 w-full h-full"
                                frameBorder="0"
                                allow="autoplay; fullscreen; picture-in-picture" allowFullScreen>
                            </iframe>
                        </div>
                    )}

                    {item_video_type === 'livid' && (
                        <div className="relative h-full w-full" style={{ paddingTop: '56.25%' }}>
                            <iframe src={item_video_src}
                                className="absolute top-0 left-0 right-0 bottom-0 w-full h-full"
                                frameBorder="0"
                                allow="autoplay; fullscreen; picture-in-picture" allowFullScreen>
                            </iframe>
                        </div>
                    )}

                    {(item_video_type !== 'youtube' && item_video_type !== 'vimeo' && item_video_type !== 'livid') && (
                        <video className="w-full h-full" controls>
                            <source src={item_video_src} />
                        </video>
                    )}
                </div>
            </ModalBody>
        </Modal>
    );
};

export default class Dashboard extends React.Component {
    state = {
        working: true,
        records: null,
        topIndex: 0,
    }

    componentDidMount = async () => {
        await this.fetchOnDemand();
    }

    // Countdown is handled by the shared <Countdown /> component

    fetchOnDemand = async () => {
        this.setState({ working: true });

        const elementReq = await ElementApi.get(null, { identifier: 'on-demand' });

        if (!elementReq.success || !elementReq.data || !elementReq.data.data || elementReq.data.data.length === 0) {
            this.setState({ working: false });
            return;
        }

        const element = elementReq.data.data[0];

        const recordsReq = await RecordApi.get(null, {
            cms_element_id: element.id,
            paginate: false,
            active: 'Yes',
            order_by: element.orderable ? 'order' : 'created_at',
            order: 'asc'
        });

        if (recordsReq.success) {
            this.setState({ records: recordsReq.data, working: false, topIndex: this.findFirstVideoIndex(recordsReq.data) });
        } else {
            this.setState({ working: false });
        }
    }

    findFirstVideoIndex = (records) => {
        if (!records || !records.data) return 0;
        const idx = records.data.findIndex(item => getRecordValue(item, 'video_src'));
        return idx === -1 ? 0 : idx;
    }

    next = () => {
        const { records, topIndex } = this.state;
        if (!records || !records.data || records.data.length === 0) return;
        this.setState({ topIndex: (topIndex + 1) % records.data.length });
    }

    prev = () => {
        const { records, topIndex } = this.state;
        if (!records || !records.data || records.data.length === 0) return;
        this.setState({ topIndex: (topIndex - 1 + records.data.length) % records.data.length });
    }

    setTopIndex = (i) => {
        this.setState({ topIndex: i });
    }

    renderVideoBody = (item, opts = {}) => {
        if (!item) return null;

        const autoplay = opts.autoplay ? 1 : 0;
        const item_video_type = getRecordValue(item, 'video_type');
        const item_video_src = getRecordValue(item, 'video_src');

        return (
            <div className="h-full w-full">
                {item_video_type === 'youtube' && (
                    <YouTube
                        videoId={item_video_src}
                        className="w-full h-full"
                        containerClassName="w-full h-80"
                        opts={{ playerVars: { autoplay: autoplay, rel: 0 } }}
                    />
                )}
                {item_video_type === 'vimeo' && (
                    <div className="relative h-full w-full" style={{paddingTop: '56.25%'}}>
                        <iframe src={item_video_src}
                            className="absolute top-0 left-0 right-0 bottom-0 w-full h-full"
                            frameBorder="0"
                            allow="autoplay; fullscreen; picture-in-picture" allowFullScreen>
                        </iframe>
                    </div>
                )}

                {item_video_type === 'livid' && (
                    <div className="relative h-full w-full" style={{paddingTop: '56.25%'}}>
                        <iframe src={autoplay && item_video_src && !/autoplay=1/.test(item_video_src) ? (item_video_src + (item_video_src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1') : item_video_src}
                            className="absolute top-0 left-0 right-0 bottom-0 w-full h-full"
                            frameBorder="0"
                            allow="autoplay; fullscreen; picture-in-picture" allowFullScreen>
                        </iframe>
                    </div>
                )}

                {(item_video_type !== 'youtube' && item_video_type !== 'vimeo' && item_video_type !== 'livid') && (
                    <video className="w-full h-full" controls>
                        <source src={item_video_src}/>
                    </video>
                )}
            </div>
        );
    }

    // modal opening/closing handled by ModalTrigger and ModalContainer

    render () {
        const { working, records, topIndex } = this.state;

        const topItem = records?.data && records.data.length > 0 ? records.data[topIndex] : null;

        return (
            <Authenticated pageVideoHeader={ "bupa-banner.mp4" } title={"Dashboard"}>
                <div className={ "space-y-12 text-center mx-auto text-app-blue" }>
                {/* Highlights strip */}
                <div className="py-12 md:py-20" style={{ backgroundColor: '#DDEDF8' }}>
                    <div className="max-w-6xl mx-auto px-8">
                        <p className="font-bold text-app-blue text-xl md:text-2xl text-center">Highlights from 2025</p>
                        <p className="text-sm text-app-blue text-left my-8 font-bold">
                            Keynotes
                        </p>

                        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                            {records && records.data ? records.data.slice(0,4).map((item, i) => {
                                let thumb = getRecordValue(item, 'thumbnail', 'file') || getRecordValue(item, 'thumbnail') || getRecordValue(item, 'video_src');
                                if (thumb && typeof thumb === 'object' && thumb.url) thumb = thumb.url;
                                const hasImage = typeof thumb === 'string' && thumb.indexOf('http') === 0;
                                const title = getRecordValue(item, 'title') || 'Highlight';

                                return (
                                    <ModalTrigger key={i} component={VideoModal} props={{ item }}>
                                        <div className="bg-app-lighter-blue rounded overflow-hidden cursor-pointer flex flex-col h-36">
                                            <div className="relative w-full flex-1">
                                                {hasImage ? (
                                                    <img src={thumb} alt={title} className="w-full h-full object-cover" />
                                                ) : (
                                                    <div className="w-full h-full flex items-center justify-center p-4 bg-app-lighter-blue">
                                                        <div className="text-white text-sm">{title}</div>
                                                    </div>
                                                )}

                                                {/* Play overlay */}
                                                <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                                                    <div className="bg-black bg-opacity-50 rounded-full py-2 px-6">
                                                        <FontAwesomeIcon icon={faPlay} className="text-white" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="p-2 text-left text-sm text-app-blue font-semibold truncate bg-app-lighter-blue">
                                            {title}
                                        </div>
                                    </ModalTrigger>
                                );
                            }) : [0,1,2,3].map(i => (
                                <div key={i} className="bg-app-lighter-blue rounded p-0 h-36 flex flex-col overflow-hidden">
                                    <div className="relative w-full flex-1 bg-app-lighter-blue flex items-center justify-center">
                                        <div className="text-white">Highlight</div>
                                        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                                            <div className="bg-black bg-opacity-50 rounded-full p-2">
                                                <FontAwesomeIcon icon={faPlay} className="text-white" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="p-2 text-left text-sm text-app-blue font-semibold truncate bg-app-lighter-blue">Highlight</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Modal interactions handled by ModalTrigger / ModalContainer; individual highlight tiles open VideoModal */}

                {/* Shared Countdown component (reads target from MIX_TARGET_DATE or window.TARGET_DATE) */}
                <div className="py-12 bg-transparent">
                    <Countdown />
                </div>

                {/* Three info cards */}
                {/*<div className="bg-app-networking py-16">*/}
                {/*    <div className="max-w-6xl mx-auto px-8 grid grid-cols-1 md:grid-cols-3 gap-8">*/}
                {/*        <div className="bg-white rounded p-10 text-center shadow-sm flex flex-col items-center justify-between min-h-[20rem] pb-6">*/}
                {/*            <div className="w-12 h-12 bg-[#51A0DC] rounded-full flex items-center justify-center text-white mb-4 flex-shrink-0">*/}
                {/*                <FontAwesomeIcon icon={faMicrophone} aria-hidden="true" className="p-2" />*/}
                {/*            </div>*/}
                {/*            <div className="font-bold text-app-blue mb-2">Speakers</div>*/}
                {/*            <div className="text-sm text-app-blue mb-6">Discover our lineup of industry leaders and innovators sharing their expertise.</div>*/}
                {/*            <DomLink to="/speakers" className="bg-app-blue text-white px-4 py-2 rounded-xl w-full max-w-xs mt-auto">View Speakers</DomLink>*/}
                {/*        </div>*/}

                {/*        <div className="bg-white rounded p-10 text-center shadow-sm flex flex-col items-center justify-between min-h-[20rem] pb-6">*/}
                {/*            <div className="w-12 h-12 bg-[#51A0DC] rounded-full flex items-center justify-center text-white mb-4 flex-shrink-0">*/}
                {/*                <FontAwesomeIcon icon={faCalendar} aria-hidden="true" className="p-2" />*/}
                {/*            </div>*/}
                {/*            <div className="font-bold text-app-blue mb-2">Agenda</div>*/}
                {/*            <div className="text-sm text-app-blue mb-6">Explore the complete schedule of sessions, workshops, and networking events.</div>*/}
                {/*            <DomLink to="/agenda" className="bg-app-blue text-white px-4 py-2 rounded-xl w-full max-w-xs mt-auto">View Agenda</DomLink>*/}
                {/*        </div>*/}

                {/*        <div className="bg-white rounded p-10 text-center shadow-sm flex flex-col items-center justify-between min-h-[20rem] pb-6">*/}
                {/*            <div className="w-12 h-12 bg-[#51A0DC] rounded-full flex items-center justify-center text-white mb-4 flex-shrink-0">*/}
                {/*                <FontAwesomeIcon icon={faBuilding} aria-hidden="true" className="p-2" />*/}
                {/*            </div>*/}
                {/*            <div className="font-bold text-app-blue mb-2">Exhibitors</div>*/}
                {/*            <div className="text-sm text-app-blue mb-6">Connect with leading companies showcasing the latest technologies.</div>*/}
                {/*            <DomLink to="/exhibitors" className="bg-app-blue text-white px-4 py-2 rounded-xl w-full max-w-xs mt-auto">View Exhibitors</DomLink>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
                {/* Join Us footer */}
                <JoinUs registerClass="bg-white text-app-blue px-4 py-2 rounded-xl" infoClass="border border-white text-white px-4 py-2 rounded-xl" />
            </Authenticated>
        );
    }
}
